export default __webpack_public_path__ + "static/media/golf.86caaf15.jpg";